import './calendar.css'
import NavTabs from '../components/calendar/NavTabs'
import HangingMenus from '../components/HangingMenus';

function Calendar() {
    return (
        <>        
            <div>
                <img className="banner__image" src={process.env.PUBLIC_URL + "/images/Oracle/calendar/banner.png"} alt="banner"/>
            </div>        
            <div className="first-head container__fluid">
                {/* <p className="oracle-about-heading">About Oracle</p>
                <p className="first-head">
                {" "}
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusamus voluptatem eligendi pariatur beatae repellendus aliquam commodi vero a necessitatibus culpa repellat harum odio, perferendis magnam unde expedita veniam voluptatibus soluta!
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusamus voluptatem eligendi pariatur beatae repellendus aliquam commodi vero a necessitatibus culpa repellat harum odio, perferendis magnam unde expedita veniam voluptatibus soluta!
                </p> */}
            </div>        
            <NavTabs />
            <HangingMenus />
        </>
    );
}

export default Calendar
